<template>
  <v-layout row wrap>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-card-title>Add Currency</v-card-title>
          <v-container>
            <v-form  @submit.prevent="postCurrency()">
              <v-text-field
                label="Name"
                v-model="currency.name"
                :rules="requiredRules"
                required
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model="currency.description"
                :rules="requiredRules"
                required
              ></v-textarea>
              <v-btn :depressed="true" color="info" v-if="update2 === false" type="submit" :loading="loading">Add Currency</v-btn>
              <v-btn :depressed="true" color="warning" v-if="update2 === true" type="submit" :loading="loading">Update Currency</v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-card-title>Currencies</v-card-title>
          <v-container>
            <table cellpadding="1" cellspacing="1" class="table">
              <thead>
              <tr>
                <td>#</td>
                <td>Name</td>
                <td>Description</td>
                <td>Action</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(currency, index) in allInventoryCurrency" :key="index">
                <td>{{index + 1}}</td>
                <td>{{currency.name}}</td>
                <td>{{currency.description}}</td>
                <td>
                  <v-btn :depressed="true" small color="warning" @click="deleteCurrency(currency.public_id)" :loading="loading">Disable</v-btn>
                  <v-btn :depressed="true" small color="info" v-if="update2 === false" @click="editCurrency(currency)" :loading="loading">Amend</v-btn>
                  <v-btn :depressed="true" small color="error" v-if="update2 === true" @click="cancelEditCurrency(index)" :loading="loading">Cancel Current Amend</v-btn>
                </td>
              </tr>
              </tbody>
            </table>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      update: false,
      update2: false,
      types: {
        name: '',
        description: '',
        public_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      currency: {
        name: '',
        description: '',
        public_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  computed: {
    loading () {
      return this.$store.state.LoadingStore.loading
    }
  },
  created () {
    this.$store.dispatch('get_all_activity_currencies')
    this.$store.dispatch('get_all_activity_types')
  },
  methods: {
    amendInventoryType: function (index) {
     
      this.update = true
      this.types.name = this.allInventoryType[index].name
      this.types.description = this.allInventoryType[index].description
      this.types.public_id = this.allInventoryType[index].public_id
    },
    cancelAmmendment: function () {
      this.update = false
      this.types.name = ''
      this.types.description = ''
      this.types.public_id = ''
    },
    deleteInventoryType: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_activity_type', data)
    },
    postInventoryType: function () {
      var instance = this
      if (this.update === false) {
        this.$store.dispatch('post_activity_type', this.types).then(function () {
          instance.cancelAmmendment()
        })
      } else {
        this.$store.dispatch('update_activity_type', this.types).then(function () {
          instance.cancelAmmendment()
        })
      }
    },
    // Currency
    deleteCurrency: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_activity_currency', data)
    },
    postCurrency: function () {
      var instance = this
      this.$store.dispatch('loading_true')
      if (this.update2 === false) {
        this.$store.dispatch('post_activity_currency', this.currency).then(function () {
          instance.currency.name = ''
          instance.currency.description = ''
        })
      } else {
        this.$store.dispatch('update_activity_currency', this.currency).then(function () {
          instance.currency.name = ''
          instance.currency.description = ''
          instance.currency.public_id = ''
          instance.update2 = false
        })
      }
    },
    editCurrency: function (currency) {
      this.update2 = true
      this.currency.name = currency.name
      this.currency.description = currency.description
      this.currency.public_id = currency.public_id
    },
    cancelEditCurrency: function () {
      this.update2 = false
      this.currency.name = ''
      this.currency.description = ''
      this.currency.public_id = ''
    }
  }
}
</script>

<style>

</style>
